import React, { createContext, useContext, useState, useEffect } from 'react';

const UserDataContext = createContext();

export const UserDataProvider = ({ children }) => {
  const [userData, setUserData] = useState(() => {
    const savedUserData = sessionStorage.getItem("app-userdata");
    return savedUserData ? JSON.parse(savedUserData) : {};
  });

  useEffect(() => {
    sessionStorage.setItem("app-userdata", JSON.stringify(userData));
  }, [userData]);

  return (
    <UserDataContext.Provider value={{ userData, setUserData }}>
      {children}
    </UserDataContext.Provider>
  );
};

export const useUserData = () => useContext(UserDataContext);